import { createInteractiveColorVars } from '../../helpers/createInteractiveColorVars/index.js';

const AbsolutesWhiteColors = createInteractiveColorVars('absolute-white');
const AbsolutesWhiteColorsLightValues = Object.freeze({
    base: {
        default: '#ffffff',
        action: '#ECECEC',
        active: '#ffffff',
        activeAction: '#ECECEC',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
});
const AbsolutesWhiteColorsDarkValues = Object.freeze({
    base: {
        default: '#ffffff',
        action: '#ECECEC',
        active: '#ffffff',
        activeAction: '#ECECEC',
    },
    text: {
        default: '#000000',
        action: '#000000',
        active: '#000000',
        activeAction: '#000000',
    },
});

export { AbsolutesWhiteColors, AbsolutesWhiteColorsDarkValues, AbsolutesWhiteColorsLightValues };
